import React, { useEffect, useState } from "react";
import {
  GstrTwoADataType,
  GstrTwoBInvoiceData,
} from "../../../commonTypes/gstTypes";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { STATES_LIST_WITH_CODE } from "../../../constant/stateListConstants";
import { CollapseClose, CollapseOpen } from "../../../assets/images";
import GstTableHeader from "../../Gst/common/GstTableHeader";
import { reverseDate } from "../../../utils/commonFunctions";
import { CircularAvatar } from "../../commons";
import { width } from "@mui/system";
import {
  ClientWiseUserTimeSheetType,
  EmployeeTimesheetType,
  TimesheetType,
} from "../../../redux/timeSheet/timeSheetType";
import { CLIENT_WISE_USER_TOTAL_TIME_AND_DATE_HEADERS } from "../../../constant/timeSheetReportDropDown/timeSheetListConst";

type AppProps = {
  data: EmployeeTimesheetType[] | [];
  tableHeader: TableHeadersType[] | [];
  setData: React.Dispatch<React.SetStateAction<[] | EmployeeTimesheetType[]>>;
};

const TimeSheetClientWiseUserTableData = ({
  data,
  tableHeader,
  setData,
}: AppProps) => {
  const handleClick = (id: number) => {
    let newClientData = data?.map((item: EmployeeTimesheetType) => {
      if (item?.user_id === id) {
        return { ...item, isOpen: !item?.isOpen };
      } else {
        return { ...item };
      }
    });
    setData([...newClientData]);
  };

  return (
    <>
      {data?.length > 0 &&
        data?.map((singleData: EmployeeTimesheetType, index: number) => {
          return (
            <>
              <tr
                style={{
                  borderBottom:
                    index === data?.length - 1 ? "1px solid #D5DADF" : "",
                }}
              >
                {tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value === "user_name") {
                    return (
                      <td colSpan={2}>
                        <div>
                          <div
                            className="d-flex justify-content-sm-start"
                            style={{ gap: "10px" }}
                          >
                            {
                              <CircularAvatar
                                name={
                                  singleData?.first_name +
                                  " " +
                                  singleData?.last_name
                                }
                                image={
                                  singleData?.profile_pic
                                    ? singleData?.profile_pic
                                    : ""
                                }
                              />
                            }

                            <div>
                              <span>
                                {singleData?.first_name +
                                  " " +
                                  singleData?.last_name}
                                <span>
                                  <span className="ml-3">
                                    {singleData?.job_title ? (
                                      <span>
                                        <span
                                          style={{
                                            color: "rgb(139, 149, 169)",
                                          }}
                                        >
                                          Designation
                                        </span>{" "}
                                        : {singleData?.job_title}
                                        {"     "}
                                      </span>
                                    ) : null}
                                  </span>
                                  {singleData?.department &&
                                  singleData?.job_title
                                    ? "|"
                                    : ""}{" "}
                                  {singleData?.department ? (
                                    <span>
                                      <span
                                        style={{ color: "rgb(139, 149, 169)" }}
                                      >
                                        Department
                                      </span>{" "}
                                      : {singleData?.department}
                                    </span>
                                  ) : null}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header.value === "total_hours") {
                    return (
                      <td style={{borderBottom:"1px solid #D5DADF"}}>
                        {!singleData.isOpen ? <div>
                          <span style={{ fontWeight:600 }}>
                            {singleData?.total_time_per_user?.toFixed(2)}
                          </span>
                        </div> : <div></div>}
                      </td>
                    );
                  } else if (header.value === "accordian") {
                    return (
                      <td
                        style={{ textAlign: "center", width: "30px" }}
                        className="data_inside_table"
                      >
                        {singleData.isOpen ? (
                          <img
                            width="20px"
                            onClick={() => handleClick(singleData?.user_id)}
                            style={{ cursor: "pointer" }}
                            src={CollapseOpen}
                            className="accordion-arrow"
                          />
                        ) : (
                          <img
                            width="20px"
                            onClick={() => handleClick(singleData?.user_id)}
                            style={{ cursor: "pointer" }}
                            src={CollapseClose}
                            className="accordion-arrow"
                          />
                        )}
                      </td>
                    );
                  }
                })}
              </tr>

              {singleData?.isOpen ? (
                <tr>
                  <td style={{ padding: "0", backgroundColor: "white" }}></td>
                  <td colSpan={3}>
                    <table className="table table-bordered table-responsive">
                      <thead className="thead-light">
                        <GstTableHeader
                          tableHeader={
                            CLIENT_WISE_USER_TOTAL_TIME_AND_DATE_HEADERS
                          }
                        />
                      </thead>

                      <tbody>
                        {singleData?.timesheets?.length > 0 &&
                          singleData?.timesheets?.map(
                            (insideData: TimesheetType) => {
                              return (
                                <>
                                  <tr>
                                    {CLIENT_WISE_USER_TOTAL_TIME_AND_DATE_HEADERS?.map(
                                      (header: TableHeadersType) => {
                                        if (header?.value === "date") {
                                          return (
                                            <td>
                                              {reverseDate(insideData?.date)}
                                            </td>
                                          );
                                        } else if (header?.value === "hours") {
                                          return (
                                            <td>
                                              {insideData?.total_time_difference?.toFixed(
                                                2
                                              )}
                                            </td>
                                          );
                                        }
                                      }
                                    )}
                                  </tr>
                                </>
                              );
                            }
                          )}
                        <tr>
                          <td
                            style={{
                              backgroundColor: "#e9ecef",
                              fontWeight: 500,
                            }}
                          >
                            Total Hours
                          </td>
                          <td
                            style={{
                              backgroundColor: "#e9ecef",
                              fontWeight: 500,
                            }}
                          >
                            {singleData?.total_time_per_user?.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              ) : null}
            </>
          );
        })}
    </>
  );
};

export default TimeSheetClientWiseUserTableData;
